var varIDs = [];
var firstError = true;

//If the user is not logged in, don't allow usage of the builder, and handle saving inputs as cookies and retrieving
$(function() {
  if(typeof isLoggedIn === 'undefined') {
    $("#recommend-equipment").prop("disabled",true);
  } else {
    $(".must-login").hide();
  }

  //Input values from cookies and save inputs to cookies
  $("#top-inputs input").each(function() {
    //If the cookie exists for an input, add it into the input box
    var cookie = getCookie("SMT-" + $(this).attr("id"));
    if(cookie != "") {
      if($(this).attr("type") == "checkbox" && cookie == "true")
        $(this).attr("checked", true);
      else
        $(this).val(cookie);
    }

    //Create an input event to save each input box value as a cookie
    $(this).on("input", function() {
      if($(this).attr("type") != "checkbox") {
        document.cookie = "SMT-" + $(this).attr("id") + "=" + $(this).val();
      } else {
        document.cookie = "SMT-" + $(this).attr("id") + "=" + $(this).is(":checked");
      }
    });
  })

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
});

//Append to body so it overlays the menu
$("#outer-popup").appendTo($("body"));

//Adds another set of inputs for another board
function addBoard(numBoard) {
  var board = $("#board-" + (numBoard-1));
  var newBoard = board.clone();
  board.find("#add-board").remove();
  newBoard.find("label").eq(0).text("Board " + numBoard + " Total Placements:").attr("for", "total-placement-" + numBoard);
  newBoard.find("#total-placement-" + (numBoard-1)).attr("id", "total-placement-" + numBoard).val("");
  newBoard.find("label").eq(1).attr("for", "qty-" + numBoard);
  newBoard.find("#qty-" + (numBoard-1)).attr("id", "qty-" + numBoard).val("");
  newBoard.find("#add-board").attr("onclick", "addBoard(" + (numBoard+1) + ");");
  newBoard.attr("id", "board-" + numBoard);
  board.after(newBoard);
}

//Display next form section
//Figure out and display recommendations
//Populate radio buttons to select machines
//Create image for selected equipment
var totalPlacements = 0;
async function recommendEquipment() {
  $("#loader").show();
  //Check if any of the inputs are empty
  if(emptyInputs())
    return;

  //Delete any of the old product data elements
  $(".prod-rec").each(function() {
    $(this).remove();
  });
  $(".radio-input").remove();
  $("#line-images").empty();

  //Hide any old errors
  $(".recs div").each(function() {
      if($(this).hasClass("error-text")) {
        $(this).remove();
      }
  });
  $("#select-recommendations").show();
  
  var leftVal = Number($("#board-size-left").val());
  var rightVal = Number($("#board-size-right").val());

  $(".board-inputs").each(function(i) {
    totalPlacements += Number($("#total-placement-" + (i + 1)).val()) * Number($("#qty-" + (i + 1)).val());
  });

  //Calculate the total placements
  totalPlacements = ((totalPlacements / 52) / 5) / 7.5;

  //Get the recommendations for the stencil, pick, and reflow machines
  var stencilPromise = findStencil(leftVal, rightVal, totalPlacements);
  var pickPromise = findPick(leftVal, rightVal, totalPlacements);
  var reflowPromise = findReflow(leftVal, rightVal, totalPlacements);

  //Make sure all of the inputs have a selection, create the line images, and show the recommendations section
  Promise.all([stencilPromise, pickPromise, reflowPromise]).then((x) => {
    //If any recommendations came back with an error (or 0 machines), only the the recommendations available and display the error text
    $(".recs div").each(function() {
      if($(this).hasClass("error-text")) {
        $("#recommendations").show();
        $("#select-recommendations").hide();
      }
      return;
    });
    $(".radio-input:first-child").click();
    $("#inline-no").click();
    $("#magazine-no").click();

    //Create the line images and sort recommendations by price
    //Then send an email to Chris/Ed with the details of the line/customer
    createLine().then(async function() {
      var emailObj = makeEmailObj();
      emailObj.name = customerAccData[0] + " " + customerAccData[1];
      emailObj.company = customerAccData[2];
      emailObj.email = customerAccData[3];
      emailObj.phone = customerAccData[4];
      emailObj.cph = totalPlacements;
      emailObj.isStaff = true;
      emailObj.inputs = [];

      $("#top-inputs input").each(function() {
        if ($(this).attr('type') == "checkbox") {
          if ($(this).prop('checked'))
            emailObj['inputs'].push($(this).attr("id") + ": true");
          else
            emailObj['inputs'].push($(this).attr("id") + ": false");
        } else {
          if($(this).attr("id") == "unique-comp")
            emailObj['inputs'].push("unique-components" + ": " + $(this).val());
          else if($(this).attr("id") == "smallest-comp")
            emailObj['inputs'].push("smallest-components" + ": " + $(this).val());
          else 
            emailObj['inputs'].push($(this).attr("id") + ": " + $(this).val());
        }
      })
      
      // console.log(emailObj);

      /* HERE const response = await fetch('https://shopapps.mannsmt.com/mann-apps/miscScripts/getProdRecommendations/emailLine-v4.php', {
        method: 'POST',
        body: JSON.stringify(emailObj),
      });
  
      if (!response.ok) {
        console.log("An error occured sending the staff email.");
      } */
    });
    sortByPrice();

    //Select the first of each radio input
    $(".radio-input:nth-child(2) input").each(function() {
      $(this).click();
    })

    //Display the recommendations
    $("#loader").hide();
    $("#recommendations").show();
    $("#cph").text(Math.round(totalPlacements).toLocaleString() + " CPH.");
    $(".cph-text").show();

    checkModal();
  });
}

//Check if any inputs are empty
function emptyInputs() {
  var inputs = $(".smt-form .form-input, #single-sided, #double-sided");
  var isEmpty = false;
  $(".error-text").hide();
  
  inputs.each(function() {
    if(Number($(this).val()) < 1) {
      $(".error-text").text("Please fill in every input above before continuing.");
      $(".error-text").show();
      isEmpty = true;
    }
  });

  if($("#board-size-left").val() < 51 || $("#board-size-right").val() < 51) {
    $(".error-text").text("Minimum board size is 51x51mm. Please enter a larger board size.");
    $(".error-text").show();
    isEmpty = true;
  }
  
  return isEmpty;
}

//Sorts the product recommendations by price in ascending order
function sortByPrice() {
  //Sort each group of recommendations
  $(".recs").each(function(j) {
    var prices = [];
    var rec = $(this);
    rec.find(".prod-rec").each(function(i) {
        prices.push(Number($(this).attr("price")));
    });

    //Bubble sort
    var sorted = false;
    do {
      sorted = true;
      prices.forEach(function(elem, i) {
        // console.log("price1: ", elem, " price2: ", prices[i+1])
        if(typeof prices[i+1] !== 'undefined' && elem > prices[i+1]) {
          var temp = prices[i+1];
          prices[i+1] = elem;
          prices[i] = temp;

          temp = rec.find(".prod-rec").eq(i+1).clone();
          rec.find(".prod-rec").eq(i+1).html(rec.find(".prod-rec").eq(i).html());
          rec.find(".prod-rec").eq(i).html(temp.html());

          temp = $(".prod-picker").eq(j).find(".radio-input").eq(i+1).clone();
          $(".prod-picker").eq(j).find(".radio-input").eq(i+1).html($(".prod-picker").eq(j).find(".radio-input").eq(i).html());
          $(".prod-picker").eq(j).find(".radio-input").eq(i).html(temp.html());
          
          sorted = false;
        }
      })
      // console.log(prices, sorted);
    } while(!sorted);

    
  });
}

//Only return the machines from leftObj and rightObj that have dimensions larger than the leftVal and rightVal
function findMatches(leftObj, rightObj, leftVal, rightVal) {
  let optionsLeft = new Set();
  Object.entries(leftObj).forEach(function([key, val]) {
    if(Number(key) >= leftVal) {
      leftObj[key].forEach(function(item, i) {
          optionsLeft.add(item);
      })
    }
  });

  var optionsRight = new Set();
  Object.entries(rightObj).forEach(function([key, val]) {
    if(Number(key) >= rightVal) {
        rightObj[key].forEach(function(item, i) {
            optionsRight.add(item);
      })
    }
  });

  //Return any machines that are still in both sets
  return optionsLeft.intersection(optionsRight);
}

//Finds the stencil printers to recommend
async function findStencil(leftVal, rightVal, CPH) {
  var stencilLeft = {
    400: ["AP435"],
    500: ["MC1400 Batch"],
    600: ["AP660"],
    610: ["MC110"],
    1200: ["AP1200", "MC1200 Batch"],
    1500: ["AP1500"]
  };

  var stencilRight = {
    300: ["AP1200", "AP1500"],
    340: ["AP435"],
    400: ["MC1400 Batch", "MC1200 Batch"],
    600: ["AP660"],
    610: ["MC110"]
  };

  var matches = findMatches(stencilLeft, stencilRight, leftVal, rightVal);

  // console.log(matches.values(), matches.has("AP435"), matches.has("AP660"), matches.has("AP1200"), matches.has("AP1500"));

  //If the AP1500 machine is with any other AP machine, remove it
  if((matches.has("AP435") || matches.has("AP660") || matches.has("AP1200")) && matches.has("AP1500")) {
    matches.delete("AP1500");
  }

  var onlyOne = new Set(["AP435", "AP660", "AP1200", "AP1500"]);

  //Delete out AP Stencil machines until one remains
  do {
    if(matches.has("AP435") && matches.has("AP660")) {
      if(leftVal <= 400 && rightVal <= 340)
        matches.delete("AP660");
      else
        matches.delete("AP435");
    } else if(matches.has("AP435") && matches.has("AP1200")) {
      if(leftVal <= 400 && rightVal <= 340)
        matches.delete("AP1200");
      else
        matches.delete("AP435");
    } else if(matches.has("AP660") && matches.has("AP1200")) {
      if(leftVal <= 600 && rightVal <= 600)
        matches.delete("AP1200");
      else
        matches.delete("AP660");
    }
  } while(matches.intersection(onlyOne).size > 1)

  if(CPH > 5000 && matches.has("MC110")) {
    matches.delete("MC110");
  }

  if(matches.size == 0) {
    $("#stencil-recs").html("<div class='error-text' error-msg='Stencil recommendation error'>Please call Chris Ellis at <a href='tel:2158698374'>215.869.8374</a> for help with selecting a stencil machine.</div>");
    $("#stencil-recs .error-text").show();
    console.log(1);
    return;
  }

  //Generate the product lines and add each into the radio selector
  const iterator1 = matches.values();
  for(var i = 0; i < 3 && i < matches.size; i++) {
    var value = iterator1.next().value;
    var [elem, title, id] = await generateProd(value);
    $("#stencil-recs").append(elem);

    var radio = `<div class="radio-input">`;
    if(i == 0) {
      radio += `<input type="radio" id="${title}" name="stencil" value="${value}" onclick="updateLine(this)" checked="checked" varID="${id}">`;
    } else {
      radio += `<input type="radio" id="${title}" name="stencil" value="${title}" onclick="updateLine(this)" varID="${id}">`;
    }
      
    radio += `<label for="${title}">${title}</label>
    </div>`;
    $(".stencil-picker").append(radio);
  }
}

//Find the pick and place machines to recommend
async function findPick(leftVal, rightVal, totalPlacements) {
  var pickLeft = {
    415: ["MC400"],
    435: ["MC385V1V", "MC385V2V"],
    600: ["MC392"],
    650: ["MC389", "MC889"],
    1200: ["MCLEDV6"],
    1250: ["MC388", "MC388HS"],
  };

  var pickRight = {
    320: ["MC400", "MCLEDV6"],
    350: ["MC385V1V", "MC385V2V", "MC392", "MC388", "MC388HS"],
    460: ["MC389", "MC889"],
  };

  //Get recommendations based on board size
  var matches = findMatches(pickLeft, pickRight, leftVal, rightVal);
  
  //Get recommendations based on feeders
  var maxComponents = Number($("#unique-comp").val()) * 0.8;
  var feederMachines = findFeeder(maxComponents);
  
  // console.log(totalPlacements);
  //Get recommendations based on CPH
  var CPHMachines = findCPH(totalPlacements);
  
  //Get the pick recommendations, which is the intersection of the other done above recommendations
  var pickRecommendations = Array.from(feederMachines.intersection(matches).intersection(CPHMachines));  

  //Check if the recommendation needs to change MC385, MC389, MC392, and MC388 to Batch
  //If the CPH is above 5500, don't show batch machines
  if(totalPlacements <= 5500) {
    if(maxComponents > 64 && maxComponents <= 128) {
      if(pickRecommendations.includes("MC385V1V"))
        pickRecommendations[pickRecommendations.indexOf("MC385V1V")] = "MC385V1V Batch";
      
      if(pickRecommendations.includes("MC385V2V"))
        pickRecommendations[pickRecommendations.indexOf("MC385V2V")] = "MC385V2V Batch";
      
    } else if(maxComponents > 96 && maxComponents <= 160) {
      if(pickRecommendations.includes("MC392"))
        pickRecommendations[pickRecommendations.indexOf("MC392")] = "MC392 Batch";
  
      if(pickRecommendations.includes("MC389"))
        pickRecommendations[pickRecommendations.indexOf("MC389")] = "MC389 Batch";
      
    } else if(maxComponents > 192 && maxComponents <= 256) {
      if(pickRecommendations.includes("MC388"))
        pickRecommendations[pickRecommendations.indexOf("MC388")] = "MC388 Batch";
      
    }
  }

  //Update the MC889 and MC388HS to be the 8-head variant if needed
  if(pickRecommendations.includes("MC889") && CPHMachines.has("MC889-V") || matches.has("MC889") && feederMachines.has("MC889") && CPHMachines.has("MC889-V")) {
    if(pickRecommendations.indexOf("MC889") >= 0) {
      pickRecommendations[pickRecommendations.indexOf("MC889")] = "MC889 8-Head";
    } else {
      pickRecommendations.push("MC889 8-Head"); 
    }
  }
  
  if(pickRecommendations.includes("MC388HS") && CPHMachines.has("MC388HS-V") || matches.has("MC388HS") && feederMachines.has("MC388HS") && CPHMachines.has("MC388HS-V")) {
    if(pickRecommendations.indexOf("MC388HS") >= 0) {
      pickRecommendations[pickRecommendations.indexOf("MC388HS")] = "MC388HS 8-Head";
    } else {
      pickRecommendations.push("MC388HS 8-Head");
    }
  }

  //If these requirements are met, there needs to be only two MC889, two MC388HS, or three MC388HS pick & place machines.
  if(totalPlacements > 22000 && maxComponents > 16) {
    halvedComp = maxComponents/2.0;
    pickRecommendations = [];

    //Check which machine should be doubled or tripled
    if(halvedComp <= 96) {
      pickRecommendations = ["MC889", "MC889"];
    } else if(halvedComp <= 192) {
      pickRecommendations = ["MC388HS", "MC388HS"];
    } else if(maxComponents/3.0 <= 192) {
      pickRecommendations = ["MC388HS", "MC388HS", "MC388HS"];
    } else {
      $("#pick-recs").html("<div class='error-text' error-msg='halvedComp was too big error'>Please call Chris Ellis at <a href='tel:2158698374'>215.869.8374</a> for help with selecting a pick & place machine.</div>");
      $("#pick-recs .error-text").show();
      console.log(2)
      return;
    }

    //Only generate one product since it is a multiple
    var [elem, title, id] = await generateProd(pickRecommendations[0], pickRecommendations.length);
    $("#pick-recs").append(elem);
    
    //Create product recs and disabled radio buttons for multiples of the same machine
      var radio = 
      `<div class="radio-input">
        <input class="mult" type="radio" id="${title}" name="pick" value="${pickRecommendations[0]}" onclick="updateLine(this)" varID="${id}">
        <span class="mult-num">(${pickRecommendations.length})&nbsp;</span><label for="${title}">${title}</label>
      </div>`;
      $(".pick-picker").append(radio);
  } else {
    // console.log(pickRecommendations);
    if(pickRecommendations.length == 0) {
      $("#pick-recs").html("<div class='error-text' error-msg='Pick & Place recommendation error'>Please call Chris Ellis at <a href='tel:2158698374'>215.869.8374</a> for help with selecting a pick & place machine.</div>");
      $("#pick-recs .error-text").show();
      console.log(3)
      return;
    }
    
    //Generate the product lines and add each into the radio selector
    for(var i = 0; i < 3 && i < pickRecommendations.length; i++) {
      var [elem, title, id] = await generateProd(pickRecommendations[i]);
      $("#pick-recs").append(elem);
    
      var radio = `<div class="radio-input">`;
      if(i == 0) {
        radio += `<input type="radio" id="${title}" name="pick" value="${pickRecommendations[i]}" onclick="updateLine(this)" checked="checked" varID="${id}">`;
      } else {
        radio += `<input type="radio" id="${title}" name="pick" value="${pickRecommendations[i]}" onclick="updateLine(this)" varID="${id}">`;
      }
        
      radio += `<label for="${title}">${title}</label>
      </div>`;
      $(".pick-picker").append(radio);
    }
  }
}

//Find the recommendations for the reflow ovens
async function findReflow(leftVal, rightVal, CPH) {
  var machines = new Set();

/*   if(leftVal <= 320 && rightVal <= 220) {
    machines.add("MC302");
  } */
  
  if(CPH <= 2500) {
    machines.add("MC302");
    machines.add("CR4000C");
  } else if(CPH <= 3000) {
    machines.add("CR4000C");
  } else if(CPH <= 9000) {
    machines.add("CR5000");
  } else {
    machines.add("CR8000");
  }

  if(machines.size == 0) {
    $("#reflow-recs").html("<div class='error-text' error-msg='Reflow recommendation error'>Please call Chris Ellis at <a href='tel:2158698374'>215.869.8374</a> for help with selecting a reflow oven.</div>");
    $("#reflow-recs .error-text").show();
    console.log(4);
    return;
  }

  //Generate the product lines and add each into the radio selector
  const iterator1 = machines.values();
  for(var i = 0; i < 3 && i < machines.size; i++) {
    var value = iterator1.next().value;
    var [elem, title, id] = await generateProd(value);
    $("#reflow-recs").append(elem);

    var radio = `<div class="radio-input">`;
    if(i == 0) {
      radio += `<input type="radio" id="${title}" name="reflow" value="${value}" onclick="updateLine(this)" checked="checked" varID="${id}">`;
    } else {
      radio += `<input type="radio" id="${title}" name="reflow" value="${title}" onclick="updateLine(this)" varID="${id}">`;
    }
      
    radio += `<label for="${title}">${title}</label>
    </div>`;
    $(".reflow-picker").append(radio);
  }
}

//Find feeder recommendations
function findFeeder(maxFeeder) {
  var machines = new Set();

  if(maxFeeder <= 16) {
    machines.add("MCLEDV6");
  }
  if(maxFeeder <= 64) {
    machines.add("MC400");
    machines.add("MC385V1V");
    machines.add("MS385V2V");
  }
  if(maxFeeder <= 96) {
    machines.add("MC889");
    machines.add("MC389");
    machines.add("MS392");
  }
  if(maxFeeder <= 128) {
    machines.add("MC385V1V");
    machines.add("MC385V2V");
  }
  if(maxFeeder <= 160) {
    machines.add("MC392");
    machines.add("MC389");
  }
  if(maxFeeder <= 192) {
    machines.add("MC388HS");
    machines.add("MC388HS");
  }
  if(maxFeeder <= 256)
    machines.add("MC388");

  return machines;
}

//Find pick & place based on CPH
function findCPH(totalPlacements) {
  var machines = new Set();

  if(totalPlacements <= 3000) {
    machines.add("MC400");
  }
  if(totalPlacements <= 5000) {
    machines.add("MC385V1V");
  }
  if(totalPlacements <= 6400) {
    machines.add("MC392");
  }
  if(totalPlacements <= 8000) {
    machines.add("MC385V2V");
  }
  if(totalPlacements <= 10500) {
    machines.add("MC389");
    machines.add("MC388");
  }
  if(totalPlacements <= 18000) {
    machines.add("MC388HS");
  }
  if(totalPlacements <= 20000) {
    machines.add("MC889");
  }
  if(totalPlacements <= 22000) {
    machines.add("MC889-V");
    machines.add("MC388HS-V");
  }
  if(totalPlacements <= 30000) {
    machines.add("MCLEDV6");
  }

  return machines;
}

//Generate the product recommendation with data from Shopify
async function generateProd(product, numMults = 1) {
  //Take out the Batch part of the MC389 to query better
  if(product == "MC389 Batch") {
    product = "MC389";
  } else if(product == "MC385V2V Batch") {
    product = "MC385V2V";
  }
  
  try {
    var response = await fetch('https://shopapps.mannsmt.com/mann-apps/miscScripts/getProdRecommendations/getProdRecommendations.php?product='+product)
    .then((response) => response.json())
    .then((data) => {
      var retVal = data.data.products.nodes[0];
      return retVal;
    });

    var price = response.variants.nodes[0].price;
    var url = response.onlineStoreUrl;
    var id = response.variants.nodes[0].id.split("/")[4];

    if(product == "MC889 8-Head" || product == "MC388HS 8-Head") {
      price = response.variants.nodes[1].price;
      url = url + "?variant=" + response.variants.nodes[1].id.split("/")[4];
      response.title = response.title + " 8-Head";
      id = response.variants.nodes[1].id.split("/")[4];
    }
    var numPrice = price;
    price = price.substring(0, price.length - 3);
    price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    
    var elem = document.createElement("div");
    elem.classList.add("prod-rec");
    elem.setAttribute("price", numPrice);
    var elemHTML = `<a href="${url}">
    <img class="prod-img" width="180px" src="${response.media.nodes[0].image.url}"></a>
    <div>
    <a href="${url}"><p class="blue-text">${response.title}</p></a>`;
    if(numMults > 1) {
      elemHTML += `<p class="multiple-machines-text">We recommend ${numMults} of these machines for your production.</p>`
    }
    elemHTML += `${response.test1.value}`;
    if(typeof isLoggedIn !== 'undefined' && isLoggedIn) {
      elemHTML += `<a href="${url}"><p class="prod-price">$${price}</p></a>`;
    } else {
      elemHTML += `<span class="login"><button class="loginLink open-modal" data-open="modal2">Login</button> or <button class="registrationLink open-modal" data-open="modal1">Sign Up</button> to View Pricing</span>`;
    }
    elemHTML += `</div>
    `;

    elem.innerHTML = elemHTML;
    return [elem, response.title, id];
  } catch (error) {
    var errorShowing = false;
    $(".error-text").each(function() {
      if($(this).css("display") == 'block')
        errorShowing = true;
    });
    if(!errorShowing) {
      $("#recommendations").html("<div class='error-text' error-msg='Generate product recommendations error'>An error occurred. Please call Chris Ellis at <a href='tel:2158698374'>215.869.8374</a> for help.</div>")
      $("#recommendations .error-text").show();
      $(".cph-text").hide();
    }

    if(firstError) {
      firstError = false;
      sendErrorEmail();
    }
  }
}

//Display the line images using the first values from each group of radio inputs
async function createLine() {
  var imageDiv = $("#line-images");

  imageDiv.append(await getLineImage(".stencil-picker"));

  //If it is recommending duplicate pick & place machines, use the mult images function
  if($(".pick-picker input").eq(0).hasClass("mult")){
    var images = await getMultImages();
    images.forEach(function(elem) {
      imageDiv.append(elem);
    });
    imageDiv.append();
  } else {
    imageDiv.append(await getLineImage(".pick-picker"));
  }
  
  imageDiv.append(await getLineImage(".reflow-picker"));
}

//Change the image line to update with whatever new product is selected
//Also select "no" for the inline and loader/unloader options and remove all line images related
async function updateLine(option) {
  $("#inline-no").click();
  $("#magazine-no").click();

  //If the option is the mcledv6, rerun the other products to use the bigger images
  if($(option).val().includes("MCLEDV6")) {
    updateLine($(".stencil-picker input:checked")[0]);
    updateLine($(".reflow-picker input:checked")[0]);
  //Otherwise, if the picker is changed, redo the other images
  } else if(typeof $(".pick-picker input:checked").val() !== 'undefined' && !$(".pick-picker input:checked").val().includes("MCLEDV6") && $(option).attr("name").includes("pick")) {
    $(".stencil-picker input:checked").click();
    $(".reflow-picker input:checked").click();
  }
  
  try {
    var response = await fetch('https://shopapps.mannsmt.com/mann-apps/miscScripts/getProdRecommendations/getLineImages-v2.php?product=' + $(option).val())
      .then((response) => response.json())
      .then((data) => {
        var retVal = data.data.products.nodes[0];
        return retVal;
      });

    if($(option).val().includes("Batch")) {
      $(".line-img." + option.name).addClass("Batch");
    } else {
      $(".line-img." + option.name).removeClass("Batch");
    }

    if($(option).val().includes("MCLEDV6")) {
      $(".line-img." + option.name).addClass("MCLEDV6");
    } else {
      $(".line-img." + option.name).removeClass("MCLEDV6");
    }

    if($(option).val().includes("MC110")) {
      $(".line-img." + option.name).addClass("Manual");
    } else {
      $(".line-img." + option.name).removeClass("Manual");
    }
    
    $(".line-img." + option.name).attr("src", getSizedImage(response));
    $(".line-img." + option.name).attr("varid", $(option).attr("varid"));
  } catch (error) {
    var errorShowing = false;
    $(".error-text").each(function() {
      if($(this).css("display") == 'block')
        errorShowing = true;
    });
    if(!errorShowing) {
      $("#recommendations").html("<div class='error-text' error-msg='Update line error'>An error occurred. Please call Chris Ellis at <a href='tel:2158698374'>215.869.8374</a> for help.</div>")
      $("#recommendations .error-text").show();
      $(".cph-text").hide();
    }
    
    if(firstError) {
      firstError = false;
      sendErrorEmail();
    }
  }
}

//Check if the line has the MCLEDV6 machine are return the correct image source with the bigger or smaller image depending on the result
function getSizedImage(response) {
  var hasMCLEDV6 = false;
  $(".radio-input input").each(function() {
    if($(this).val().includes("MCLEDV6"))
      hasMCLEDV6 = true;
    
  });
  // console.log(response);

  //Use the bigger version if the line has an MCLEDV6 in it (and the bigger version exists). Otherwise, use the standard sized image
  if(hasMCLEDV6 && typeof response.metafield.references.nodes[1] !== 'undefined' && $(".pick-picker .radio-input input:checked").val().includes("MCLEDV6")) {
    return response.metafield.references.nodes[1].image.url;
  } else {
    return response.metafield.references.nodes[0].image.url;
  }
}

//Return multiples of the same image to not have to fetch multiple times
async function getMultImages() {
  var allImages = [];
  var regex = /\((\d+)\)/;
  var numImages = $(".pick-picker .mult-num").text().match(regex)[1];
  
  try {
    var response = await fetch('https://shopapps.mannsmt.com/mann-apps/miscScripts/getProdRecommendations/getLineImages-v2.php?product=' + $(".pick-picker input").eq(0).val())
    .then((response) => response.json())
    .then((data) => {
      var retVal = data.data.products.nodes[0];
      return retVal;
    });

    for(var i = 0; i < numImages; i++) {
      var image = $("<img>").addClass("line-img " + $(".pick-picker input").eq(0).attr("name"));
      if(i > 0) {
        image.addClass("duplicate");
      }
      image.attr("src", getSizedImage(response));
      image.attr("varid", $(".pick-picker input").eq(0).attr("varid"));
      allImages.push(image);
    }

    return allImages;
    } catch (error) {
      var errorShowing = false;
      $(".error-text").each(function() {
        if($(this).css("display") == 'block')
          errorShowing = true;
      });
      if(!errorShowing) {
        $("#recommendations").html("<div class='error-text' error-msg='Mult image error'>An error occurred. Please call Chris Ellis at <a href='tel:2158698374'>215.869.8374</a> for help.</div>")
        $("#recommendations .error-text").show();
        $(".cph-text").hide();
      }

      if(firstError) {
        firstError = false;
        sendErrorEmail();
      }
    }
}

//Get the line image and create an image element
async function getLineImage(className) {
  try {
    var response = await fetch('https://shopapps.mannsmt.com/mann-apps/miscScripts/getProdRecommendations/getLineImages-v2.php?product=' + $(className + " .radio-input input:checked").val())
    .then((response) => response.json())
    .then((data) => {
      var retVal = data.data.products.nodes[0];
      // console.log("getLineImage() - ", data);
      return retVal;
    });

    var image = $("<img>").addClass("line-img " + $(className + " .radio-input input:checked").attr("name"));
    // console.log($(className + " .radio-input input:checked").val());
    if($(className + " .radio-input input:checked").val().includes("Batch"))
      image.addClass("Batch");

    if($(className + " .radio-input input:checked").val().includes("MCLEDV6"))
      image.addClass("MCLEDV6");

    if($(className + " .radio-input input:checked").val().includes("MC302"))
      image.addClass("MC302");

    if($(className + " .radio-input input:checked").val().includes("MC110"))
      image.addClass("Manual");
    
    image.attr("src", getSizedImage(response));
    image.attr("varid", $(className + " .radio-input input:checked").attr("varid"));

    return image;
  } catch (error) {
    var errorShowing = false;
    $(".error-text").each(function() {
      if($(this).css("display") == 'block')
        errorShowing = true;
    });
    if(!errorShowing) {
      $("#recommendations").html("<div class='error-text' error-msg='Line image error'>An error occurred. Please call Chris Ellis at <a href='tel:2158698374'>215.869.8374</a> for help.</div>")
      $("#recommendations .error-text").show();
      $(".cph-text").hide();
    }

    if(firstError) {
      firstError = false;
      sendErrorEmail();
    }
  }
}

//Check if the inline should be shown between certain machines, and display/don't display
function showInline(show) {
  var images = $(".line-img");
  var hasMCLEDV6 = false;
  var hasInline = false;
  $(".line-img").each(function() {
    if($(this).hasClass("MCLEDV6"))
      hasMCLEDV6 = true;

    if($(this).hasClass("inline"))
      hasInline = true;
  });


  if(show) {
    for(var i = 0; i < images.length; i++) {
      //If the line image's neighbors exist, neighbors do not have the Batch class, the neighbors aren't loaders,
      //the next neighbor isn't the MC302, it and it's next neighbor isn't a manual machine, it isn't a duplicate, and inline machines are not already loaded, add an inline machine      
      // console.log((images.eq(i).prev().length, !images.eq(i).prev().hasClass("Batch")), !images.eq(i).hasClass("Batch"), $("#inline-yes").is(":checked"), !images.eq(i).hasClass("loader"), !images.eq(i).prev().hasClass("loader"), !images.eq(i).hasClass("MC302"))
      if((images.eq(i).prev().length && !images.eq(i).prev().hasClass("Batch")) && !images.eq(i).hasClass("Batch") && !images.eq(i).hasClass("loader") && !images.eq(i).prev().hasClass("loader") 
        && !images.eq(i).hasClass("MC302") && !images.eq(i).hasClass("Manual") && !images.eq(i).prev().hasClass("Manual") && !images.eq(i).hasClass("duplicate") && !hasInline) {
        if(hasMCLEDV6) {
          $("<img>").addClass("line-img inline").attr("src", "https://cdn.shopify.com/s/files/1/0582/5213/2491/files/bc-100-mcledv6-size-01.svg?v=1741380148").attr("varid", "40316101722251").insertBefore(images.eq(i));
        } else {
          $("<img>").addClass("line-img inline").attr("src", "https://cdn.shopify.com/s/files/1/0582/5213/2491/files/bc-100-01.svg?v=1741380137").attr("varid", "40316101722251").insertBefore(images.eq(i));
        }
      }
    }
  } else {
    $(".line-img.inline").remove();
  }
}

//Check if the loader should be shown, and display/don't display it
function showLoader(show) {
  var images = $(".line-img");
  var hasMCLEDV6 = false;
  var hasLoader = false;
  $(".line-img").each(function() {
    if($(this).hasClass("MCLEDV6"))
      hasMCLEDV6 = true;

    if($(this).hasClass("loader"))
      hasLoader = true;
  });


  if(show) {
    if(!hasLoader) {
      //If the stencil machine is batch or manual and the pick & place machine is not batch, place the loader in front of the pick & place.
      if(!images.eq(0).hasClass("Batch") && !images.eq(0).hasClass("Manual")) {
        if(hasMCLEDV6) {
          $("<img>").addClass("line-img loader").attr("src", "https://cdn.shopify.com/s/files/1/0582/5213/2491/files/loader-mcledv6-size-01.svg?v=1741380148").attr("varid","40316104081547").insertBefore(images.eq(0));
        } else {
          $("<img>").addClass("line-img loader").attr("src", "https://cdn.shopify.com/s/files/1/0582/5213/2491/files/loader-01.svg?v=1741380137").attr("varid","40316104081547").insertBefore(images.eq(0));
        }
      } else if(!$(".line-img.pick").hasClass("Batch")) {
        if(hasMCLEDV6) {
          $("<img>").addClass("line-img loader").attr("src", "https://cdn.shopify.com/s/files/1/0582/5213/2491/files/loader-mcledv6-size-01.svg?v=1741380148").attr("varid","40316104081547").insertBefore($(".line-img.pick").eq(0));
        } else {
          $("<img>").addClass("line-img loader").attr("src", "https://cdn.shopify.com/s/files/1/0582/5213/2491/files/loader-01.svg?v=1741380137").attr("varid","40316104081547").insertBefore($(".line-img.pick").eq(0));
        }
      }
    }

    if(!$(".reflow-picker input:checked").val().includes("MC302")) {
      if(hasMCLEDV6) {
        $("<img>").addClass("line-img loader").attr("src", "https://cdn.shopify.com/s/files/1/0582/5213/2491/files/unloader-mcledv6-size-01.svg?v=1741380148").attr("varid","40316104835211").insertAfter(images.last());
      } else {
        $("<img>").addClass("line-img loader").attr("src", "https://cdn.shopify.com/s/files/1/0582/5213/2491/files/unloader-01.svg?v=1741380137").attr("varid","40316104835211").insertAfter(images.last());
      }
    }
  } else {
    $(".line-img.loader").remove();
  }
}

//Close the modal and allow scrolling again
$(".close").eq(0).on("click", function() {
  const scrollY = document.body.style.top;

  document.body.style.position = '';
  document.body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
  $("#outer-popup").hide();
});

//Open the modal and create the click event to send an email
async function shareLine() {
  //Disable scrolling
  $("#outer-popup").show();

  //Make only the modal scrollable, and set it to be reversable
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
  document.body.style.top = `-${scrollY}`;
  

  //When clicked, send an email to the specified email addresses
  $("#send-email").on("click", async function() {
    var emailObj = makeEmailObj();
    
    const response = await fetch('https://shopapps.mannsmt.com/mann-apps/miscScripts/getProdRecommendations/emailLine-v4.php', {
      method: 'POST',
      body: JSON.stringify(emailObj),
    });

    if (!response.ok) {
      $("#response-text").html('<p class="error-text" error-msg="Error sharing line.">An error occured, please try again later.</p>');
      return;
    }
    
    returnedText = await response.json();
    $("#response-text").html(returnedText.html); 
  });
}

function makeEmailObj() {
    var emailObj = {
      name: $("#share-name").val(),
      company: $("#share-company").val(),
      email: $("#share-email").val().trim(),
      phone: $("#share-phone").val(),
      recipient: [],
      lineProducts: "This line includes the ",
      allProducts: [],
      extraInfo: [],
    };

    $(".recipients input").each(function() {
      emailObj['recipient'].push($(this).val());
    });

    //Create text that says what is in the line the user chose
    var machineIndex = 1;
    $("#line-images img").each(function(i) {
      if(i == $("#line-images img").length - 1) {
        emailObj['lineProducts'] += "and ";
      }

      //Create text that says what machines are in the line
      if($(this).hasClass("loader")) {
        emailObj['lineProducts'] += "BL-460W Magazine Loader, "
      } else if($(this).hasClass("inline")) {
        emailObj['lineProducts'] += "BC-100X Inline Conveyor, "
      } else if(machineIndex == 2 && $(".pick-picker input").eq(0).hasClass("mult")) {
        emailObj['lineProducts'] += $(".pick-picker .mult-num").text() + $(".pick-picker .mult-num + label").eq(0).text() + ", ";
        machineIndex++;
      //Don't run the duplicate pick & place machines again
      } else if(!$(this).hasClass("duplicate")) {
        //Make sure the text isn't blank
        if($(".prod-picker > div:nth-child(" + machineIndex + ") input:checked + label").text() !== '') {
          emailObj['lineProducts'] += $(".prod-picker > div:nth-child(" + machineIndex + ") input:checked + label").text() + ", ";
        }
        machineIndex++;
      }
    });
    emailObj['lineProducts'] = emailObj['lineProducts'].slice(0, -2); 
    emailObj['lineProducts'] += ".";

    //Create text for every product recommended
    emailObj['lineImg'] = $("#line-images").html();
    $(".prod-picker > div").each(function(i) {
      emailObj['allProducts'][i] = [];
      $(this).children().each(function(j) {
        //If there are multiples of the pick & place machine, just count them instead of individually listing them
        if(i == 1 && $(".pick-picker input").eq(0).hasClass("mult")) {
          emailObj['allProducts'][i].push($(this).text()/* + " (" + $(".pick-picker input").length + ")"*/)
        } else {
          emailObj['allProducts'][i].push($(this).text());
        }
      });
    });

    var loaders = 0;
    var unloaders = 0;
    var inlines = 0;
    $("#line-images img").each(function() {
      if($(this).attr("src").includes("loader"))
        loaders++;

      if($(this).attr("src").includes("unloader"))
        unloaders++;

      if($(this).hasClass("inline"))
        inlines++;
    })

    //Add conveyors to the allProducts text
    var conveyorIndex = emailObj['allProducts'].length
    if(loaders > 0 || inlines > 0 || unloaders > 0) {
      emailObj['allProducts'][conveyorIndex] = []; 
      emailObj['allProducts'][conveyorIndex].push("Conveyors:");
    }
    if(loaders > 0)
      emailObj['allProducts'][conveyorIndex].push("Magazine Loader");
    if(inlines == 1) {
      emailObj['allProducts'][conveyorIndex].push(inlines + " Inline Conveyor");
    } else if(inlines > 1) {
      emailObj['allProducts'][conveyorIndex].push(inlines + " Inline Conveyors");
    }
    if(unloaders > 0)
      emailObj['allProducts'][conveyorIndex].push("Magazine Unloader");

    if($("#single-sided").is(':checked')) {
      emailObj['extraInfo'].push("Single-sided boards");
    }

    if($("#double-sided").is(':checked')) {
      emailObj['extraInfo'].push("Double-sided boards");
    }

    emailObj['extraInfo'].push("Smallest component size of " + $("#smallest-comp").val());

  return emailObj;
}

//Keep track of the scroll position of the window to reset back to after the modal is closed
window.addEventListener('scroll', () => {
  document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
});

//Duplicate recipient box for multiple recipients
function addRecipient(numRecipient) {
  var recipient = $("#recipient-" + numRecipient);
  var email = $("#share-team-email-" + numRecipient);

  var newRecipient = recipient.clone();
  
  $(".add-recipient").attr("onclick", "addRecipient(" + (numRecipient+1) +");")
  newRecipient.find("#share-team-email-" + numRecipient).attr("id", "share-team-email-" + (numRecipient+1)).val("");
  newRecipient.attr("id", "recipient-" + (numRecipient+1));
  recipient.after(newRecipient);
}

//When the "Add to Quote" button is clicked, add the machines into the cart and go to the quote page
function addToQuote() {
  let formData = {
     'items': []
    };
  
  $(".line-img").each(function() { 
    formData['items'].push({
      "id": $(this).attr("varid"),
      "quantity": 1
    });
  });
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    // console.log(response.json());
    location.href = "https://www.manncorp.com/apps/request-quote?page=request";
    return;
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

async function sendErrorEmail() {
  var emailObj = makeEmailObj();
  emailObj.name = customerAccData[0] + " " + customerAccData[1];
  emailObj.company = customerAccData[2];
  emailObj.email = customerAccData[3];
  emailObj.phone = customerAccData[4];
  emailObj.cph = totalPlacements;
  emailObj.isStaff = true;
  emailObj.inputs = [];
  emailObj.errorText = $(".error-text:visible").attr("error-msg");

  $("#top-inputs input").each(function() {
    if ($(this).attr('type') == "checkbox") {
      if ($(this).prop('checked'))
        emailObj['inputs'].push($(this).attr("id") + ": true");
      else
        emailObj['inputs'].push($(this).attr("id") + ": false");
    } else {
      if($(this).attr("id") == "unique-comp")
        emailObj['inputs'].push("unique-components" + ": " + $(this).val());
      else if($(this).attr("id") == "smallest-comp")
        emailObj['inputs'].push("smallest-components" + ": " + $(this).val());
      else 
        emailObj['inputs'].push($(this).attr("id") + ": " + $(this).val());
    }
  })


  const response = await fetch('https://shopapps.mannsmt.com/mann-apps/miscScripts/getProdRecommendations/emailLine-Error.php', {
    method: 'POST',
    body: JSON.stringify(emailObj),
  });
}